import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpFavoriteBusStop,
  HttpFavoriteBusStopParams,
  IFavoriteBusStopParser,
} from "../lineInfoRepository.types";
import { IFavoriteBusStop } from "@/domain/entities/favoriteBusStop";

@injectable()
export class FavoriteBusStopParser implements IFavoriteBusStopParser {
  constructor() {}

  toDomain(data: HttpFavoriteBusStop): Result<IFavoriteBusStop, ParseError> {
    try {
      const busStop: IFavoriteBusStop = {
        uid: data.lineStationUid,
        name: data.name,
        shorName: data.shorName,
        lat: data.lat,
        lng: data.lng,
        displayOrder: data.displayOrder,
      };
      return ok(busStop);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }

  fromDomain(data: IFavoriteBusStop): HttpFavoriteBusStopParams | ParseError {
    try {
      const busStop: HttpFavoriteBusStopParams = {
        stationUid: data.uid,
        name: data.name,
        shorName: data.shorName,
        lat: data.lat,
        lng: data.lng,
        displayOrder: data.displayOrder,
      };
      return busStop;
    } catch (error: any) {
      return new ParseError(error.message);
    }
  }
}
